var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollect3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 627.442,
    height: 491.919,
    viewBox: "0 0 627.442 491.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.372,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5dfd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14578",
    "data-name": "Group 14578",
    transform: "translate(-1068.558 -7710)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14216",
    "data-name": "Group 14216",
    transform: "translate(1578.086 7710) rotate(90)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2957",
    "data-name": "Ellipse 2957",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3198",
    "data-name": "Ellipse 3198",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2958",
    "data-name": "Ellipse 2958",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2959",
    "data-name": "Ellipse 2959",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3200",
    "data-name": "Ellipse 3200",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2960",
    "data-name": "Ellipse 2960",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2833",
    "data-name": "Ellipse 2833",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3088",
    "data-name": "Ellipse 3088",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2834",
    "data-name": "Ellipse 2834",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2835",
    "data-name": "Ellipse 2835",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3090",
    "data-name": "Ellipse 3090",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2836",
    "data-name": "Ellipse 2836",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2961",
    "data-name": "Ellipse 2961",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3202",
    "data-name": "Ellipse 3202",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2962",
    "data-name": "Ellipse 2962",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2963",
    "data-name": "Ellipse 2963",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3204",
    "data-name": "Ellipse 3204",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2964",
    "data-name": "Ellipse 2964",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2837",
    "data-name": "Ellipse 2837",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3092",
    "data-name": "Ellipse 3092",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2838",
    "data-name": "Ellipse 2838",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2839",
    "data-name": "Ellipse 2839",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3094",
    "data-name": "Ellipse 3094",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2840",
    "data-name": "Ellipse 2840",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2965",
    "data-name": "Ellipse 2965",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3206",
    "data-name": "Ellipse 3206",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2966",
    "data-name": "Ellipse 2966",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2967",
    "data-name": "Ellipse 2967",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3208",
    "data-name": "Ellipse 3208",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2968",
    "data-name": "Ellipse 2968",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2841",
    "data-name": "Ellipse 2841",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3096",
    "data-name": "Ellipse 3096",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2842",
    "data-name": "Ellipse 2842",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2843",
    "data-name": "Ellipse 2843",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3098",
    "data-name": "Ellipse 3098",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2844",
    "data-name": "Ellipse 2844",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2969",
    "data-name": "Ellipse 2969",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3210",
    "data-name": "Ellipse 3210",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2970",
    "data-name": "Ellipse 2970",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2845",
    "data-name": "Ellipse 2845",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3100",
    "data-name": "Ellipse 3100",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2846",
    "data-name": "Ellipse 2846",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2971",
    "data-name": "Ellipse 2971",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3212",
    "data-name": "Ellipse 3212",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2972",
    "data-name": "Ellipse 2972",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2847",
    "data-name": "Ellipse 2847",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3102",
    "data-name": "Ellipse 3102",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2848",
    "data-name": "Ellipse 2848",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2973",
    "data-name": "Ellipse 2973",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3214",
    "data-name": "Ellipse 3214",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2974",
    "data-name": "Ellipse 2974",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2975",
    "data-name": "Ellipse 2975",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3216",
    "data-name": "Ellipse 3216",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2976",
    "data-name": "Ellipse 2976",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2849",
    "data-name": "Ellipse 2849",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3104",
    "data-name": "Ellipse 3104",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2850",
    "data-name": "Ellipse 2850",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2851",
    "data-name": "Ellipse 2851",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3105",
    "data-name": "Ellipse 3105",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2852",
    "data-name": "Ellipse 2852",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2977",
    "data-name": "Ellipse 2977",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3218",
    "data-name": "Ellipse 3218",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2978",
    "data-name": "Ellipse 2978",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2979",
    "data-name": "Ellipse 2979",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3220",
    "data-name": "Ellipse 3220",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2980",
    "data-name": "Ellipse 2980",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2853",
    "data-name": "Ellipse 2853",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3107",
    "data-name": "Ellipse 3107",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2854",
    "data-name": "Ellipse 2854",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2855",
    "data-name": "Ellipse 2855",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3108",
    "data-name": "Ellipse 3108",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2856",
    "data-name": "Ellipse 2856",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2981",
    "data-name": "Ellipse 2981",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3222",
    "data-name": "Ellipse 3222",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2982",
    "data-name": "Ellipse 2982",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2983",
    "data-name": "Ellipse 2983",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3224",
    "data-name": "Ellipse 3224",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2984",
    "data-name": "Ellipse 2984",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2857",
    "data-name": "Ellipse 2857",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3110",
    "data-name": "Ellipse 3110",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2858",
    "data-name": "Ellipse 2858",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2859",
    "data-name": "Ellipse 2859",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3111",
    "data-name": "Ellipse 3111",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2860",
    "data-name": "Ellipse 2860",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2985",
    "data-name": "Ellipse 2985",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3226",
    "data-name": "Ellipse 3226",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2986",
    "data-name": "Ellipse 2986",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2861",
    "data-name": "Ellipse 2861",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3112",
    "data-name": "Ellipse 3112",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2862",
    "data-name": "Ellipse 2862",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2987",
    "data-name": "Ellipse 2987",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3228",
    "data-name": "Ellipse 3228",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2988",
    "data-name": "Ellipse 2988",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2863",
    "data-name": "Ellipse 2863",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3113",
    "data-name": "Ellipse 3113",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2864",
    "data-name": "Ellipse 2864",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2925",
    "data-name": "Ellipse 2925",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3114",
    "data-name": "Ellipse 3114",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2926",
    "data-name": "Ellipse 2926",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2927",
    "data-name": "Ellipse 2927",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3116",
    "data-name": "Ellipse 3116",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2928",
    "data-name": "Ellipse 2928",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2865",
    "data-name": "Ellipse 2865",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3118",
    "data-name": "Ellipse 3118",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2798",
    "data-name": "Ellipse 2798",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2866",
    "data-name": "Ellipse 2866",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3119",
    "data-name": "Ellipse 3119",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2799",
    "data-name": "Ellipse 2799",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2929",
    "data-name": "Ellipse 2929",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3121",
    "data-name": "Ellipse 3121",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2930",
    "data-name": "Ellipse 2930",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2931",
    "data-name": "Ellipse 2931",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3123",
    "data-name": "Ellipse 3123",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2932",
    "data-name": "Ellipse 2932",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2867",
    "data-name": "Ellipse 2867",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3125",
    "data-name": "Ellipse 3125",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2800",
    "data-name": "Ellipse 2800",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2868",
    "data-name": "Ellipse 2868",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3126",
    "data-name": "Ellipse 3126",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2801",
    "data-name": "Ellipse 2801",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2933",
    "data-name": "Ellipse 2933",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3128",
    "data-name": "Ellipse 3128",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2934",
    "data-name": "Ellipse 2934",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2935",
    "data-name": "Ellipse 2935",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3130",
    "data-name": "Ellipse 3130",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2936",
    "data-name": "Ellipse 2936",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2869",
    "data-name": "Ellipse 2869",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3132",
    "data-name": "Ellipse 3132",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2802",
    "data-name": "Ellipse 2802",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2870",
    "data-name": "Ellipse 2870",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3133",
    "data-name": "Ellipse 3133",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2803",
    "data-name": "Ellipse 2803",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2937",
    "data-name": "Ellipse 2937",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3134",
    "data-name": "Ellipse 3134",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2938",
    "data-name": "Ellipse 2938",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2871",
    "data-name": "Ellipse 2871",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3136",
    "data-name": "Ellipse 3136",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2804",
    "data-name": "Ellipse 2804",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2939",
    "data-name": "Ellipse 2939",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3137",
    "data-name": "Ellipse 3137",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2940",
    "data-name": "Ellipse 2940",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2805",
    "data-name": "Ellipse 2805",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3139",
    "data-name": "Ellipse 3139",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2806",
    "data-name": "Ellipse 2806",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2941",
    "data-name": "Ellipse 2941",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3140",
    "data-name": "Ellipse 3140",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2942",
    "data-name": "Ellipse 2942",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2943",
    "data-name": "Ellipse 2943",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3142",
    "data-name": "Ellipse 3142",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2944",
    "data-name": "Ellipse 2944",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2872",
    "data-name": "Ellipse 2872",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3144",
    "data-name": "Ellipse 3144",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2807",
    "data-name": "Ellipse 2807",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2873",
    "data-name": "Ellipse 2873",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3145",
    "data-name": "Ellipse 3145",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2808",
    "data-name": "Ellipse 2808",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2945",
    "data-name": "Ellipse 2945",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3147",
    "data-name": "Ellipse 3147",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2946",
    "data-name": "Ellipse 2946",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2947",
    "data-name": "Ellipse 2947",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3149",
    "data-name": "Ellipse 3149",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2948",
    "data-name": "Ellipse 2948",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2874",
    "data-name": "Ellipse 2874",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3151",
    "data-name": "Ellipse 3151",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2809",
    "data-name": "Ellipse 2809",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2875",
    "data-name": "Ellipse 2875",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3152",
    "data-name": "Ellipse 3152",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2810",
    "data-name": "Ellipse 2810",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2949",
    "data-name": "Ellipse 2949",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3154",
    "data-name": "Ellipse 3154",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2950",
    "data-name": "Ellipse 2950",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2951",
    "data-name": "Ellipse 2951",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3156",
    "data-name": "Ellipse 3156",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2952",
    "data-name": "Ellipse 2952",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2876",
    "data-name": "Ellipse 2876",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3158",
    "data-name": "Ellipse 3158",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2811",
    "data-name": "Ellipse 2811",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2877",
    "data-name": "Ellipse 2877",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3159",
    "data-name": "Ellipse 3159",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2812",
    "data-name": "Ellipse 2812",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2953",
    "data-name": "Ellipse 2953",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3160",
    "data-name": "Ellipse 3160",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2954",
    "data-name": "Ellipse 2954",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2878",
    "data-name": "Ellipse 2878",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3162",
    "data-name": "Ellipse 3162",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2813",
    "data-name": "Ellipse 2813",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2955",
    "data-name": "Ellipse 2955",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3163",
    "data-name": "Ellipse 3163",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2956",
    "data-name": "Ellipse 2956",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2814",
    "data-name": "Ellipse 2814",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3165",
    "data-name": "Ellipse 3165",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2815",
    "data-name": "Ellipse 2815",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2879",
    "data-name": "Ellipse 2879",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3166",
    "data-name": "Ellipse 3166",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2880",
    "data-name": "Ellipse 2880",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2881",
    "data-name": "Ellipse 2881",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3168",
    "data-name": "Ellipse 3168",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2882",
    "data-name": "Ellipse 2882",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2885",
    "data-name": "Ellipse 2885",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3170",
    "data-name": "Ellipse 3170",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2886",
    "data-name": "Ellipse 2886",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2887",
    "data-name": "Ellipse 2887",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3172",
    "data-name": "Ellipse 3172",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2888",
    "data-name": "Ellipse 2888",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2891",
    "data-name": "Ellipse 2891",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3174",
    "data-name": "Ellipse 3174",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2892",
    "data-name": "Ellipse 2892",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2893",
    "data-name": "Ellipse 2893",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3176",
    "data-name": "Ellipse 3176",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2894",
    "data-name": "Ellipse 2894",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2897",
    "data-name": "Ellipse 2897",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3178",
    "data-name": "Ellipse 3178",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2898",
    "data-name": "Ellipse 2898",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2900",
    "data-name": "Ellipse 2900",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3180",
    "data-name": "Ellipse 3180",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2901",
    "data-name": "Ellipse 2901",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2902",
    "data-name": "Ellipse 2902",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3182",
    "data-name": "Ellipse 3182",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2903",
    "data-name": "Ellipse 2903",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2904",
    "data-name": "Ellipse 2904",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3184",
    "data-name": "Ellipse 3184",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2905",
    "data-name": "Ellipse 2905",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2989",
    "data-name": "Ellipse 2989",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3230",
    "data-name": "Ellipse 3230",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2990",
    "data-name": "Ellipse 2990",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2991",
    "data-name": "Ellipse 2991",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3232",
    "data-name": "Ellipse 3232",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2992",
    "data-name": "Ellipse 2992",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2908",
    "data-name": "Ellipse 2908",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3186",
    "data-name": "Ellipse 3186",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2909",
    "data-name": "Ellipse 2909",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2910",
    "data-name": "Ellipse 2910",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3188",
    "data-name": "Ellipse 3188",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2911",
    "data-name": "Ellipse 2911",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2993",
    "data-name": "Ellipse 2993",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3234",
    "data-name": "Ellipse 3234",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2994",
    "data-name": "Ellipse 2994",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2995",
    "data-name": "Ellipse 2995",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3236",
    "data-name": "Ellipse 3236",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2996",
    "data-name": "Ellipse 2996",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2914",
    "data-name": "Ellipse 2914",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3190",
    "data-name": "Ellipse 3190",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2915",
    "data-name": "Ellipse 2915",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2916",
    "data-name": "Ellipse 2916",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3192",
    "data-name": "Ellipse 3192",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2917",
    "data-name": "Ellipse 2917",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2997",
    "data-name": "Ellipse 2997",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3238",
    "data-name": "Ellipse 3238",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2998",
    "data-name": "Ellipse 2998",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2999",
    "data-name": "Ellipse 2999",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3240",
    "data-name": "Ellipse 3240",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3000",
    "data-name": "Ellipse 3000",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2920",
    "data-name": "Ellipse 2920",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3194",
    "data-name": "Ellipse 3194",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2921",
    "data-name": "Ellipse 2921",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3001",
    "data-name": "Ellipse 3001",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3242",
    "data-name": "Ellipse 3242",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3002",
    "data-name": "Ellipse 3002",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2923",
    "data-name": "Ellipse 2923",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3196",
    "data-name": "Ellipse 3196",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2924",
    "data-name": "Ellipse 2924",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3003",
    "data-name": "Ellipse 3003",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3244",
    "data-name": "Ellipse 3244",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3004",
    "data-name": "Ellipse 3004",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -117.914)",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14217",
    "data-name": "Group 14217",
    transform: "translate(1062.086 8082) rotate(90)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2957-2",
    "data-name": "Ellipse 2957",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2958-2",
    "data-name": "Ellipse 2958",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2959-2",
    "data-name": "Ellipse 2959",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2960-2",
    "data-name": "Ellipse 2960",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2833-2",
    "data-name": "Ellipse 2833",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2834-2",
    "data-name": "Ellipse 2834",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2835-2",
    "data-name": "Ellipse 2835",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2836-2",
    "data-name": "Ellipse 2836",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2961-2",
    "data-name": "Ellipse 2961",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2963-2",
    "data-name": "Ellipse 2963",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2964-2",
    "data-name": "Ellipse 2964",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2837-2",
    "data-name": "Ellipse 2837",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2839-2",
    "data-name": "Ellipse 2839",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2840-2",
    "data-name": "Ellipse 2840",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2965-2",
    "data-name": "Ellipse 2965",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2967-2",
    "data-name": "Ellipse 2967",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2968-2",
    "data-name": "Ellipse 2968",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2841-2",
    "data-name": "Ellipse 2841",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2843-2",
    "data-name": "Ellipse 2843",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2844-2",
    "data-name": "Ellipse 2844",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2969-2",
    "data-name": "Ellipse 2969",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2845-2",
    "data-name": "Ellipse 2845",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2971-2",
    "data-name": "Ellipse 2971",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2847-2",
    "data-name": "Ellipse 2847",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2973-2",
    "data-name": "Ellipse 2973",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2974-2",
    "data-name": "Ellipse 2974",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2975-2",
    "data-name": "Ellipse 2975",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2976-2",
    "data-name": "Ellipse 2976",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2849-2",
    "data-name": "Ellipse 2849",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2850-2",
    "data-name": "Ellipse 2850",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2851-2",
    "data-name": "Ellipse 2851",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2852-2",
    "data-name": "Ellipse 2852",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2977-2",
    "data-name": "Ellipse 2977",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2979-2",
    "data-name": "Ellipse 2979",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2980-2",
    "data-name": "Ellipse 2980",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2853-2",
    "data-name": "Ellipse 2853",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2855-2",
    "data-name": "Ellipse 2855",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2856-2",
    "data-name": "Ellipse 2856",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2981-2",
    "data-name": "Ellipse 2981",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2983-2",
    "data-name": "Ellipse 2983",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2984-2",
    "data-name": "Ellipse 2984",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2857-2",
    "data-name": "Ellipse 2857",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2859-2",
    "data-name": "Ellipse 2859",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2860-2",
    "data-name": "Ellipse 2860",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2985-2",
    "data-name": "Ellipse 2985",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2861-2",
    "data-name": "Ellipse 2861",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2987-2",
    "data-name": "Ellipse 2987",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2863-2",
    "data-name": "Ellipse 2863",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2925-2",
    "data-name": "Ellipse 2925",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2926-2",
    "data-name": "Ellipse 2926",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2927-2",
    "data-name": "Ellipse 2927",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2928-2",
    "data-name": "Ellipse 2928",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2865-2",
    "data-name": "Ellipse 2865",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2798-2",
    "data-name": "Ellipse 2798",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2866-2",
    "data-name": "Ellipse 2866",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2799-2",
    "data-name": "Ellipse 2799",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2929-2",
    "data-name": "Ellipse 2929",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2931-2",
    "data-name": "Ellipse 2931",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2932-2",
    "data-name": "Ellipse 2932",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2867-2",
    "data-name": "Ellipse 2867",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2868-2",
    "data-name": "Ellipse 2868",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2801-2",
    "data-name": "Ellipse 2801",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2933-2",
    "data-name": "Ellipse 2933",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2935-2",
    "data-name": "Ellipse 2935",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2936-2",
    "data-name": "Ellipse 2936",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2869-2",
    "data-name": "Ellipse 2869",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2870-2",
    "data-name": "Ellipse 2870",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2803-2",
    "data-name": "Ellipse 2803",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2937-2",
    "data-name": "Ellipse 2937",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2871-2",
    "data-name": "Ellipse 2871",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2939-2",
    "data-name": "Ellipse 2939",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2805-2",
    "data-name": "Ellipse 2805",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2941-2",
    "data-name": "Ellipse 2941",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2942-2",
    "data-name": "Ellipse 2942",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2943-2",
    "data-name": "Ellipse 2943",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2944-2",
    "data-name": "Ellipse 2944",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2872-2",
    "data-name": "Ellipse 2872",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2807-2",
    "data-name": "Ellipse 2807",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2873-2",
    "data-name": "Ellipse 2873",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2808-2",
    "data-name": "Ellipse 2808",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2945-2",
    "data-name": "Ellipse 2945",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2947-2",
    "data-name": "Ellipse 2947",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2948-2",
    "data-name": "Ellipse 2948",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2874-2",
    "data-name": "Ellipse 2874",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2875-2",
    "data-name": "Ellipse 2875",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2810-2",
    "data-name": "Ellipse 2810",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2949-2",
    "data-name": "Ellipse 2949",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2951-2",
    "data-name": "Ellipse 2951",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2952-2",
    "data-name": "Ellipse 2952",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2876-2",
    "data-name": "Ellipse 2876",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2877-2",
    "data-name": "Ellipse 2877",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2812-2",
    "data-name": "Ellipse 2812",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2953-2",
    "data-name": "Ellipse 2953",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2878-2",
    "data-name": "Ellipse 2878",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2955-2",
    "data-name": "Ellipse 2955",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2814-2",
    "data-name": "Ellipse 2814",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2879-2",
    "data-name": "Ellipse 2879",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2880-2",
    "data-name": "Ellipse 2880",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2881-2",
    "data-name": "Ellipse 2881",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2882-2",
    "data-name": "Ellipse 2882",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2885-2",
    "data-name": "Ellipse 2885",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2887-2",
    "data-name": "Ellipse 2887",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2888-2",
    "data-name": "Ellipse 2888",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2891-2",
    "data-name": "Ellipse 2891",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2893-2",
    "data-name": "Ellipse 2893",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2894-2",
    "data-name": "Ellipse 2894",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2897-2",
    "data-name": "Ellipse 2897",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2900-2",
    "data-name": "Ellipse 2900",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2902-2",
    "data-name": "Ellipse 2902",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2903-2",
    "data-name": "Ellipse 2903",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2904-2",
    "data-name": "Ellipse 2904",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2905-2",
    "data-name": "Ellipse 2905",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2989-2",
    "data-name": "Ellipse 2989",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2990-2",
    "data-name": "Ellipse 2990",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2991-2",
    "data-name": "Ellipse 2991",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2992-2",
    "data-name": "Ellipse 2992",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2908-2",
    "data-name": "Ellipse 2908",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2910-2",
    "data-name": "Ellipse 2910",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2911-2",
    "data-name": "Ellipse 2911",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2993-2",
    "data-name": "Ellipse 2993",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2995-2",
    "data-name": "Ellipse 2995",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2996-2",
    "data-name": "Ellipse 2996",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2914-2",
    "data-name": "Ellipse 2914",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2916-2",
    "data-name": "Ellipse 2916",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2917-2",
    "data-name": "Ellipse 2917",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2997-2",
    "data-name": "Ellipse 2997",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2999-2",
    "data-name": "Ellipse 2999",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3000-2",
    "data-name": "Ellipse 3000",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2920-2",
    "data-name": "Ellipse 2920",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3001-2",
    "data-name": "Ellipse 3001",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3003-2",
    "data-name": "Ellipse 3003",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -117.914)",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8618",
    "data-name": "Group 8618",
    transform: "translate(300 7600)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8505",
    "data-name": "Group 8505",
    transform: "translate(811 120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3062",
    "data-name": "Rectangle 3062",
    transform: "translate(0 22)",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 542,
    height: 432,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 541,
    height: 431,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Nov_12",
    "data-name": "Nov 12",
    transform: "translate(51 428)",
    fill: "#111",
    fontSize: 13,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.293,
    y: 0
  }, "Nov 12")), /*#__PURE__*/React.createElement("text", {
    id: "Nov_13",
    "data-name": "Nov 13",
    transform: "translate(124 428)",
    fill: "#111",
    fontSize: 13,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.403,
    y: 0
  }, "Nov 13")), /*#__PURE__*/React.createElement("text", {
    id: "Nov_14",
    "data-name": "Nov 14",
    transform: "translate(197 428)",
    fill: "#111",
    fontSize: 13,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.748,
    y: 0
  }, "Nov 14")), /*#__PURE__*/React.createElement("text", {
    id: "Nov_15",
    "data-name": "Nov 15",
    transform: "translate(272 428)",
    fill: "#111",
    fontSize: 13,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.696,
    y: 0
  }, "Nov 15")), /*#__PURE__*/React.createElement("text", {
    id: "Nov_16",
    "data-name": "Nov 16",
    transform: "translate(346 428)",
    fill: "#111",
    fontSize: 13,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.715,
    y: 0
  }, "Nov 16")), /*#__PURE__*/React.createElement("text", {
    id: "Nov_18",
    "data-name": "Nov 18",
    transform: "translate(493 428)",
    fill: "#111",
    fontSize: 13,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.689,
    y: 0
  }, "Nov 18")), /*#__PURE__*/React.createElement("text", {
    id: "Nov_17",
    "data-name": "Nov 17",
    transform: "translate(420 428)",
    fill: "#111",
    fontSize: 13,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.182,
    y: 0
  }, "Nov 17")), /*#__PURE__*/React.createElement("line", {
    id: "Line_171",
    "data-name": "Line 171",
    x2: 481.095,
    transform: "translate(30.5 396.5)",
    fill: "none",
    stroke: "#d7dfe6",
    strokeWidth: 1,
    strokeDasharray: "7 7"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_172",
    "data-name": "Line 172",
    y1: 260,
    transform: "translate(31.722 130.5)",
    fill: "none",
    stroke: "#d7dfe6",
    strokeWidth: 1,
    strokeDasharray: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8543",
    "data-name": "Group 8543",
    transform: "translate(435.486 47.999)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Last_7_days",
    "data-name": "Last 7 days",
    transform: "translate(66 13)",
    fill: "#848b9c",
    fontSize: 13,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -71.643,
    y: 0
  }, "Last 7 days")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M10.516,14.7l3.272-3.275a.616.616,0,0,1,.873,0,.624.624,0,0,1,0,.876l-3.708,3.71a.617.617,0,0,1-.853.018L6.368,12.307a.619.619,0,1,1,.873-.876Z",
    transform: "translate(66.42 -4.246)",
    fill: "#5d6578"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_3_63_835.01",
    "data-name": "3,63,835.01",
    transform: "translate(271 101)",
    fill: "#111",
    fontSize: 26,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "-0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -70.2,
    y: 0
  }, "3,63,835.01")), /*#__PURE__*/React.createElement("g", {
    id: "Group_8565",
    "data-name": "Group 8565",
    transform: "translate(215 111.798)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_5_000.00",
    "data-name": "5,000.00",
    transform: "translate(32.924 16)",
    fill: "#777",
    fontSize: 15,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5,000.00")), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-down-right",
    "data-name": "Icon feather-arrow-down-right",
    transform: "translate(17 6.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M10.5,18.722,17.645,10.5",
    transform: "translate(-10.5 -10.5)",
    fill: "none",
    stroke: "#12a15a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M17.645,18.722V10.5H10.5",
    transform: "translate(-10.5 -10.5)",
    fill: "none",
    stroke: "#12a15a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8568",
    "data-name": "Group 8568",
    transform: "translate(225 49.999)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Deposit",
    transform: "translate(35 16.001)",
    fill: "#777",
    fontSize: 15,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "0.09em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.845,
    y: 0
  }, "DEPOSIT")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down-2",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M11.169,15.225l3.766-3.769a.709.709,0,0,1,1.005,0,.718.718,0,0,1,0,1.008l-4.267,4.27a.71.71,0,0,1-.982.021L6.4,12.467A.712.712,0,0,1,7.4,11.459Z",
    transform: "translate(75.327 -2.246)",
    fill: "#777"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14263",
    "data-name": "Group 14263",
    transform: "translate(-712 -223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_185-united_states_of_america",
    "data-name": "185-united states of america",
    transform: "translate(733 275.706)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2500",
    "data-name": "Rectangle 2500",
    width: 26.623,
    height: 16.468,
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7436",
    "data-name": "Group 7436",
    transform: "translate(0 2.122)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2501",
    "data-name": "Rectangle 2501",
    width: 26.623,
    height: 2.122,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2502",
    "data-name": "Rectangle 2502",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 4.075)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2503",
    "data-name": "Rectangle 2503",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 8.149)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2507",
    "data-name": "Rectangle 2507",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 14.345)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2504",
    "data-name": "Rectangle 2504",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 12.223)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2505",
    "data-name": "Rectangle 2505",
    width: 13.724,
    height: 9.853,
    transform: "translate(0 0)",
    fill: "#2e52b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7437",
    "data-name": "Group 7437",
    transform: "translate(1.394 1.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M83.3,160.624l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42H83.52Z",
    transform: "translate(-79.342 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M83.52,207.077l-.221-.68-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-79.342 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M27.158,207.077l-.221-.68-.221.68H26l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-26.001 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M26.937,160.624l-.221.68H26l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-26.001 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M83.3,114.85l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42H83.52Z",
    transform: "translate(-79.342 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M26.937,114.85l-.221.68H26l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-26.001 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M139.661,160.624l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-132.682 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M139.882,207.077l-.221-.68-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-132.682 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M196.245,207.077l-.221-.68-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-186.024 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M196.024,160.624l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-186.024 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M139.661,114.85l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-132.682 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M196.024,114.85l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-186.024 -114.85)",
    fill: "#f0f0f0"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "USD",
    transform: "translate(769 293)",
    fill: "#111",
    fontSize: 22,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "USD")))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M-12246.94,12732.3c1.2-.455,84.2,49.659,84.2,49.659l61.2-56.809,70.717,50.149,81.587-50.149,50.878,14.205,40.394-40.237v188H-12338v-101.957",
    transform: "translate(13180.94 -12371.299)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3124",
    "data-name": "Rectangle 3124",
    width: 2,
    height: 212,
    transform: "translate(933 304)",
    fill: "#12a15a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    transform: "translate(929 355)",
    fill: "#12a15a",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8547",
    "data-name": "Group 8547",
    transform: "translate(950.611 322)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3125",
    "data-name": "Rectangle 3125",
    width: 120,
    height: 60,
    rx: 6,
    transform: "translate(0.389)",
    fill: "#41594b"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2_365.00",
    "data-name": "2,365.00",
    transform: "translate(32.389 22)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2,365.00")), /*#__PURE__*/React.createElement("text", {
    id: "Nov_16_2022",
    "data-name": "Nov 16, 2022",
    transform: "translate(67.717 45)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.692,
    y: 0
  }, "Nov 16, 2022")), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-down-right-2",
    "data-name": "Icon feather-arrow-down-right",
    transform: "translate(21.918 37.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1518-2",
    "data-name": "Path 1518",
    d: "M9.087,17.685,16.368,10.5",
    transform: "translate(-10.081 -10.5)",
    fill: "none",
    stroke: "#61ce65",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519-2",
    "data-name": "Path 1519",
    d: "M16.813,16.919,16.787,10.5H10.5",
    transform: "translate(-10.5 -10.5)",
    fill: "none",
    stroke: "#61ce65",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollect3);
export default __webpack_public_path__ + "static/media/collect_3.493e2b1a5f21e8c54e0b58bdaf31939f.svg";
export { ForwardRef as ReactComponent };